module.exports = __webpack_public_path__ + "static/storyboard2-3a36ee1f4a8e3c3b65cc5eaca181800c.gif";